export const CRYPTO_SECRET_KEY = "rOdEo_ApP";

export const DOB_MONTHS = [
  { value: 1, label: "January" },
  { value: 2, label: "February" },
  { value: 3, label: "March" },
  { value: 4, label: "April" },
  { value: 5, label: "May" },
  { value: 6, label: "June" },
  { value: 7, label: "July" },
  { value: 8, label: "August" },
  { value: 9, label: "September" },
  { value: 10, label: "October" },
  { value: 11, label: "November" },
  { value: 12, label: "December" },
];

export const YES_NO_RADIO = [
  {
    label: "No",
    value: "no",
  },
  {
    label: "Yes",
    value: "yes",
  },
];

export const GENDER_RADIO = [
  {
    label: "Male",
    value: "male",
  },
  {
    label: "Female",
    value: "female",
  },
  {
    label: "Other",
    value: "other",
  },
];

//This varibale is using based on navigation bar is marque tag is show/hide
export const RODEO_PAGE_NAME = {
  LOGIN: "login",
  AUTO_LOGIN: "auto_login",
  DASHBOARD: "dashboard",
  EVENT_LIST: "event_list",
  PAST_EVENT_LIST: "past_event_list",
  CHALLENGE_LIST: "challenge_list",
  CHALLENGE_DETAILS: "challenge_details",
  RIDER_LIST: "rider_list",
  QUESTION_ANSWER_LIST: "question_answer_list",
  EVENT_GAME_LIST: "event_game_list",
  PERFORMANCE_LIST: "performance_list",
  EVENT_GAME_DETAILS: "event_game_details",
  MY_ACCOUNT: "my_account",
  CMS: "cms",
  ABOUT_US: "about_us",
  LEGAL: "legal",
  LEADERBOARD: "leaderboard",
  HOW_TO_PLAY: "how-to-play",
  TERM_OF_USE: "term-of-use",
  NOT_FOUND_PAGE: "not-found",
  PRIZES_LIST: "prizes-list",
  PRIZE: "prize",
  WINNING_TICKET: "winning-ticket",
  MY_TEAM: "my-team",
  TEAM_IMAGE: "team-image",
  MOST_POPULAR_PICKS: "most-popular-picks",
};

export const CLOUDFRONT_STATIC_URL = "https://d22z93bum7xzz9.cloudfront.net/assets/share_image/";

export const PROFILE_IMAGE_ASPECT_RATIO = 1;

export const SOCKET_CHANNEL = {
  START_EVENT: "RQStartEvent",
  STATUS_MESSAGE: "RQStatusMsg",
  IR_STATUS_MSG: "irStatusMsg",
  VOTE_RIDER: "rpUserPick",
  ANSWER_WINNER: "RQAnswerWinner",
  TV_BOARD_IMAGE: "RQTvBoardEmit",
  ADV_PROMOTION: "RQAdsPromotion",
  APP_REDIRECT: "appRedirect",
  START_STOP_RP_EVENT: "sartStoptRpEvent",
  COUPON: "couponInsideRodeo",
  LOGIN_REQUIRED: "gameLoginRequired",
  CONTESTANT_WINNER: "rpContestantWinner",
  EVENT_GLOW: "eventGlow",
  PICK_STATUS_UPDATE: "RQPickStatusUpdate",
  END_EVENT: "RQEndEvent",
  PERFORMANCE_STATUS_UPDATE: "RQPerformanceStatusUpdate",
};

export const EVENT_STATUS = {
  NOT_STARTED: 0,
  ONGOING: 1,
  END: 2,
};

export const CUSTOM_MESSAGE = {
  SEND_OTP: "6 digit OTP has been sent successfully",
  RESENT_OTP: "OTP Resend successfully.",
};
